import { AxiosResponse } from 'axios'
import { createClient } from 'urql'
import { LIST_ACTION_NEEDED, gqlClientOptions } from 'gql'
import axiosClient from './base'
import { RequestLevel } from '../constants'

// ResolveActionItem v2
const RESOLVE_ACTION_ITEM_PATH_V2 = (id: string) => `/api/action-needed/${id}/resolve-action`

const UPDATE_ACTION_ITEM_PATH_V2 = (id: string) => `/api/action-needed/${id}/update-action`

// ResolveActionItem v2
export const resolveAction = (
	id: string,
	data: IResolveActionItemParams
): Promise<AxiosResponse<IActionItemUpdateResponse>> =>
	axiosClient.post<Promise<AxiosResponse<IActionItemUpdateResponse>>, IResolveActionItemParams>(
		RESOLVE_ACTION_ITEM_PATH_V2(id),
		data
	)

// UpdateActionItem v2
export const updateActionItemV2 = (
	id: string,
	data: IUpdateActionItemParams
): Promise<AxiosResponse<IActionItemUpdateResponse>> =>
	axiosClient.put<Promise<AxiosResponse<IActionItemUpdateResponse>>, IUpdateActionItemParams>(
		UPDATE_ACTION_ITEM_PATH_V2(id),
		data
	)

export const getPendingActionItemsV2 = (
	level: RequestLevel,
	take?: number,
	practiceId?: string
) => {
	const graphQLClientOptions = {
		practiceId,
		requestLevel: level
	}
	const graphQLClient = createClient(gqlClientOptions(graphQLClientOptions))
	return graphQLClient
		.query(LIST_ACTION_NEEDED, {
			where: {
				isComplete: false
			},
			take: take ?? 1
		})
		.toPromise()
}
